<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9947 14.6232V15.96H7.03711V14.6232H10.9947ZM11.1459 11.3304V12.636H7.03711V11.3304H11.1459ZM14.1867 8.00641V9.34321H7.03711V8.00641H14.1867Z"
      class="fill-current"
    />
    <path
      d="M9.97687 20.5416H5.80567C4.31527 20.5416 3.10327 19.3296 3.10327 17.8392V6.12241C3.10327 4.63201 4.31527 3.42001 5.80567 3.42001H17.5225C19.0129 3.42001 20.2249 4.63201 20.2249 6.12241V8.00401C20.2249 8.34001 19.9513 8.61361 19.6153 8.61361C19.2793 8.61361 19.0057 8.34001 19.0057 8.00401V6.12241C19.0057 5.30401 18.3409 4.63681 17.5201 4.63681H5.80567C4.98727 4.63681 4.32007 5.30161 4.32007 6.12241V17.8392C4.32007 18.6576 4.98487 19.3248 5.80567 19.3248H9.97687C10.3129 19.3248 10.5865 19.5984 10.5865 19.9344C10.5865 20.2704 10.3129 20.5416 9.97687 20.5416Z"
      class="fill-current"
    />
    <path
      d="M13.3849 20.58C13.2241 20.58 13.0681 20.5152 12.9553 20.4024L10.5649 18.012C10.3273 17.7744 10.3273 17.388 10.5649 17.1504C10.8025 16.9128 11.1889 16.9128 11.4265 17.1504L13.3849 19.1088L19.8577 12.636C20.0953 12.3984 20.4817 12.3984 20.7193 12.636C20.9569 12.8736 20.9569 13.26 20.7193 13.4976L13.8145 20.4C13.7017 20.5152 13.5457 20.58 13.3849 20.58Z"
      class="fill-current"
    />
  </svg>
</template>
